"use client";

import { c as _c } from "react/compiler-runtime";
import { BodyLong } from "@navikt/ds-react";
import { ComponentHeader } from "@/components/header/ComponentHeader";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
interface Props {
  vurdering: AktivitetskravVurdering;
}
export const IkkeOppfyltComponent = t0 => {
  const $ = _c(5);
  const {
    vurdering
  } = t0;
  let t1;
  if ($[0] !== vurdering.sistVurdert) {
    t1 = <ComponentHeader headerText={"Svarfristen har g\xE5tt ut"} utsendtDato={vurdering.sistVurdert} alertStyle="warning" />;
    $[0] = vurdering.sistVurdert;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4"><BodyLong>Hei!</BodyLong><BodyLong>Svarfristen til forhåndsvarslet har gått ut. NAV vurderer fremdeles aktivitetsplikten din. Du vil motta ny informasjon så snart NAV har fullført vurderingen.</BodyLong></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};